/**
 * FG Magnit — related products top-up.
 * The section renders what it can from the product's collections. If that is
 * short of the limit, this fetches products of the same type, then the same
 * brand, from the storefront search and appends the ones not already shown.
 */
class FgRelated extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('[data-fg-grid]');
    this.limit = Number(this.dataset.limit) || 6;
    this.exclude = new Set((this.dataset.exclude || '').split('|').filter(Boolean));
    if (!this.grid) return;
    this.fill();
  }

  get shown() {
    return this.grid.querySelectorAll('.fg-related__item').length;
  }

  async fill() {
    // Each tier: [query, keep(item) -> boolean]. Search matches words inside a
    // type ("Dryer" also finds "Hair Dryer"), so the type tier keeps exact matches only.
    const tiers = [
      [this.dataset.typeQuery, (li) => li.dataset.type === this.dataset.type],
      [this.dataset.titleQuery, () => true],
      [this.dataset.vendorQuery, (li) => li.dataset.vendor === this.dataset.vendor],
    ].filter(([q]) => q);
    for (const [q, keep] of tiers) {
      if (this.shown >= this.limit) break;
      try {
        const url = `${this.dataset.searchUrl}?view=fg-related&type=product&q=${encodeURIComponent(q)}`;
        const res = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!res.ok) continue;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        doc.querySelectorAll('.fg-related__item').forEach((li) => {
          if (this.shown >= this.limit) return;
          const id = li.dataset.id;
          if (!id || this.exclude.has(id) || !keep(li)) return;
          this.exclude.add(id);
          this.grid.appendChild(document.importNode(li, true));
        });
      } catch (e) {
        /* the row simply stays as rendered */
      }
    }
    if (this.shown > 0) this.hidden = false;
  }
}

if (!customElements.get('fg-related')) {
  customElements.define('fg-related', FgRelated);
}
